<template>
  <ListView
    modelName="SalesDelivery"
    perm="sales.menu_sales_delivery"    
    svg="icon_side_shipment"
    color="steelblue"
    :items.sync="items"
    :params.sync="params"
    title="menu_sales_delivery"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="SalesDelivery"
    :gridCaptions="listCaptions"
    :gridWidths="listWidths"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    @selected="onSelectedMain"
    borderColor="#E35F71"
    backColor="#FFF1F3"        
    tourId="291622"
    :comparer="(a,b)=>a.deliveryNo == b.deliveryNo"          
    :deleteHandler="onDelete"
    :postAddHandler="submitBundleAddDeliveryItemRun"    
    :popup="popup"            
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="listSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="salesDeliveryStatus"/></GridItem>
    <GridItem :slot="listSlots[1]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.deliveryNo }}</GridItem>
    <GridItem :slot="listSlots[2]" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow" :perm="$refs.mainList.perm+'.approve'"/></GridItem>    
    <GridItem :slot="listSlots[3]" slot-scope="{ item }">{{ item.deliveryDate | date }}</GridItem>    
    <GridItem :slot="listSlots[4]" slot-scope="{ item }">{{ item.counterpart.name }}</GridItem>
    <GridItem :slot="listSlots[5]" slot-scope="{ item }">{{ item.receiver?item.receiver.name:'' }}</GridItem>
    <GridItem :slot="listSlots[6]" slot-scope="{ item }">{{ item.outputReceiverName }}</GridItem>
    <GridItem :slot="listSlots[7]" slot-scope="{ item }">{{ item.deliveryFlag | deliveryFlagsHasServices }}</GridItem>
    <GridItem :slot="listSlots[8]" slot-scope="{ item }">{{ item.warehouse?item.warehouse.name:'' }}</GridItem>
    <GridItem :slot="listSlots[9]" slot-scope="{ item }">{{ item.currencyCode | currency }}</GridItem>
    <GridItem :slot="listSlots[10]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.currencyCode) }}</GridItem>
    <!-- <GridItem :slot="listSlots[12]" slot-scope="{ item }">{{ item.exchangeRate }}</GridItem> -->
    <GridItem :slot="listSlots[11]" slot-scope="{ item }">{{ ( item.counterpart ? item.counterpart.taxType : null ) | taxTypes }}</GridItem>
    <GridItem :slot="listSlots[12]" slot-scope="{ item }">{{ item.projectItem?item.projectItem.name:'' }}</GridItem>        
    <GridItem :slot="listSlots[13]" slot-scope="{ item }">{{ item.segmentId | segment }}</GridItem>
    <GridItem :slot="listSlots[14]" slot-scope="{ item }">{{ item.pic | userGroup }}</GridItem>
    <GridItem :slot="listSlots[15]" slot-scope="{ item }">{{ item.refNo }}</GridItem>
    <GridItem :slot="listSlots[16]" slot-scope="{ item }">{{ item.forwarder | forwarderFlags }}</GridItem>
    <GridItem :slot="listSlots[17]" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[18]" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem :slot="listSlots[19]" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[20]" slot-scope="{ item }">{{ item.lastUpdatedBy | user  }}</GridItem>
    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView"  :electronicBookMode="tenantSettings.electronicBookMode" ref="menuBar" :getKeyValue="(obj)=>obj.deliveryNo" reportHtml="<p class='cx_dialog_html'>※特定得意先の専用帳票を簡単に出力することが可能です。<br>　詳細は<a href='https://support.s-flow.net/ja/articles/8159389-特定の得意先専用の見積書-納品書-請求書を簡単に出力したい' target='_blank'>こちら</a>をご参照ください。</p>">
          <ListViewMenu title="一括請求処理"  @click="showBookSalesDialogBulk" tooltip="選択された伝票に対して請求処理を実施します。"/>
          <ListViewMenu title="個別請求処理"  @click="showBookSalesDialogSeparate" tooltip="選択された伝票に対して個別請求処理を実施します。選択された出荷伝票が1つの個別請求データに集約されます。請求先の異なる伝票は処理できません。"/>
          <ListViewMenu title="ピッキング処理" @click="showPickingDialog" />
          <ListViewMenu slot="report" title="得意先指定帳票出力"  @click="showCustomerReport" tooltip="【得意先】の【出荷一覧指定帳票】で指定された帳票を出力します。詳細は<a href='https://support.s-flow.net/ja/articles/8159389' target='_blank'>サポートサイト</a>をご確認ください。"/>
          <ListViewMenu slot="mail" title="得意先指定帳票送信"  @click="showCustomerReport(true)" tooltip="【得意先】の【出荷一覧指定帳票】で指定された帳票をメール送信します。詳細は<a href='https://support.s-flow.net/ja/articles/8159389' target='_blank'>サポートサイト</a>をご確認ください。"/>
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView" :tabs="['検索条件','取引先区分','予備項目']">
        <FilterBox title="出荷番号" :value.sync="params.deliveryNo" @click="handler" />
        <FilterBox title="出荷管理番号" :value.sync="params.refNo" @click="handler" />
        <FilterBox title="受注番号" :value.sync="params.orderNo" @click="handler" />
        <FilterBox title="ピッキング番号" :value.sync="params.pickingNo" @click="handler" />        
        <FilterBox title="備考" :value.sync="params.description" @click="handler" />
        <FilterBox title="得意先名称" :value.sync="params.counterpartName" @click="handler"/>
        <FilterBox title="納入先名称" :value.sync="params.receiverName" @click="handler" tooltip='納入先詳細タブの納入先名称を部分一致で検索できます。' />
        <ComboBox title="得意先締日" :value.sync="params.counterpartClosingDate" list="dateTypes" :nullValue="0" :showDefault="false" @changed="handler" tooltip='指定した日が【締日1】もしくは【締日2】に設定されていて【請求区分】が【締請求】である得意先の伝票を検索します。'/>
        <AtcCounterpart title="得意先" :value.sync="params.counterpart" :needsCustomer="true" @changed="handler" />
        <AtcCounterpart title="納入先" :value.sync="params.receiver" :needsCustomer="true" :needsReceiver="true" @changed="handler" />
        <AtcCounterpart title="出庫倉庫" :value.sync="params.warehouse" :needsWarehouse="true" @changed="handler" />
        <AtcProjectItem title="案件" :value.sync="params.projectItem" @changed="handler"/>           
        <AtcSegment title="部門" :value.sync="params.segment" @changed="handler" />
        <AutoComplete title="担当者" :value.sync="params.pic" list="user" @changed="handler" />
        <AutoComplete title="取引通貨"  :value.sync="params.currencyCode" list="currency" @changed="handler" v-if="hasLicenseCurrency" />          
        <Calendar title="出荷日(From)" :value.sync="params.deliveryDateFrom" :deletable="true" @changed="handler" :autoEntry="true" :dateFlag.sync="params.deliveryDateFromFlag"/>
        <Calendar title="出荷日(To)" :value.sync="params.deliveryDateTo" :deletable="true" @changed="handler" :autoEntry="true" :dateFlag.sync="params.deliveryDateToFlag"/>
        <FilterBox title="出荷金額(From)" :value.sync="params.dealAmountFcFrom" :isNumber="true" @click="handler" />
        <FilterBox title="出荷金額(To)" :value.sync="params.dealAmountFcTo" :isNumber="true" @click="handler" />
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />            
        <ComboBox title="状態" :value.sync="params.state" list="salesDeliveryStatus" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->
        <ComboBox slot="tab1" title="category_1" :value.sync="params.category1" list="category_1" @changed="handler" />
        <ComboBox slot="tab1" title="category_2" :value.sync="params.category2" list="category_2" @changed="handler" />
        <ComboBox slot="tab1" title="category_3" :value.sync="params.category3" list="category_3" @changed="handler" />
        <ComboBox slot="tab1" title="category_4" :value.sync="params.category4" list="category_4" @changed="handler" />
        <ComboBox slot="tab1" title="category_5" :value.sync="params.category5" list="category_5" @changed="handler" />
        <ComboBox slot="tab1" title="category_6" :value.sync="params.category6" list="category_6" @changed="handler" />

        <FilterBox slot="tab2" title="voucher_text1" :value.sync="params.reserveText1" @click="handler"   />
        <FilterBox slot="tab2" title="voucher_text2" :value.sync="params.reserveText2" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text3" :value.sync="params.reserveText3" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text4" :value.sync="params.reserveText4" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text5" :value.sync="params.reserveText5" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text6" :value.sync="params.reserveText6" @click="handler" />
        <ComboBox slot="tab2" title="voucher_list1" :value.sync="params.reserveList1" list="category_31" @changed="handler" />
        <ComboBox slot="tab2" title="voucher_list2" :value.sync="params.reserveList2" list="category_32" @changed="handler" />
        <ComboBox slot="tab2" title="voucher_list3" :value.sync="params.reserveList3" list="category_33" @changed="handler" />         
        <Calendar slot="tab2" title="voucher_date1|(From)" :value.sync="params.reserveDate1From" :deletable="true" @changed="handler"/>
        <Calendar slot="tab2" title="voucher_date1|(To)" :value.sync="params.reserveDate1To" :deletable="true" @changed="handler" />
        <Calendar slot="tab2" title="voucher_date2|(From)" :value.sync="params.reserveDate2From" :deletable="true" @changed="handler" />
        <Calendar slot="tab2" title="voucher_date2|(To)" :value.sync="params.reserveDate2To" :deletable="true" @changed="handler" />
        <Calendar slot="tab2" title="voucher_date3|(From)" :value.sync="params.reserveDate3From" :deletable="true" @changed="handler"/>
        <Calendar slot="tab2" title="voucher_date3|(To)" :value.sync="params.reserveDate3To" :deletable="true" @changed="handler" />     
        <FilterBox slot="tab2" title="voucher_memo1" :value.sync="params.reserveMemo1" @click="handler"/>
        <FilterBox slot="tab2" title="voucher_memo2" :value.sync="params.reserveMemo2" @click="handler"/>
        <FilterBox slot="tab2" title="voucher_memo3" :value.sync="params.reserveMemo3" @click="handler"/> 
      </Search>
    </template>
    <!-- フルサイズエディタの配置(ListView:fullSizeEditor="true"を指定) -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','出荷明細','記載事項','納入先詳細','予備項目','ワークフロー','更新履歴','添付ファイル']" :tabVisibles="listView.isInsertMode ? tabVisiblesOnInsert: tabVisibles" :tabTooltips="[null,'出荷番号に紐づいている【出荷明細】を確認することができます。','任意に出荷データに関わる詳細情報を編集できるタブです。','基本情報タブで選択した納入先の情報が編集できます。','任意にテキスト入力・区分の設定・日付設定を行えます｡項目名は【テナント設定】＞【取引先予備項目】から変更が可能です。内容は帳票に載せることができます。',null,null,null]">
        <!-- エディタ編集・機能ボタン -->
        <template slot="menu" slot-scope="{ item, editor}">
          <SplitButton class="button" @click="showDirectAccessDialg(item)" caption="関連伝票"  icon="account_tree" tooltip="関連する伝票へのリンクを表示します。">                
            <Button class="button" @click="showSalesDeliveryItem" caption="明細表示" :disabled="editor.isEdit || disabledShowItemButton" icon="arrow_downward" tooltip="選択した出荷に紐づいている【出荷明細】の一覧を表示します。"/>
          </SplitButton>
          <!-- <Button class="button" @click="showBundleAddDeliveryItemDialog" caption="明細の追加" :disabled="editor.isEdit || disabledAddItemButton(item)" icon="add" tooltip="選択した出荷に紐づく【出荷明細】の登録を行います。"/> -->
        </template>
        <template slot="menu_right" slot-scope="{item}">   
          <Button class="button" @click="showBookSalesDialog(item,true)" caption="請求処理" v-if="! disabledDeliveryItemFuncButton(item)"  :perm="$refs.mainList.perm + '.process'" :disabled="$refs.salesDeliveryItems && $refs.salesDeliveryItems.isLoading" />                        
        </template>                
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <TextBox title="出荷番号" :value="item.deliveryNo" :editor="editor" :enabled="false" tooltip="初回保存時に先頭に”SD”がつく番号が自動で付与されます。この番号は手動で変更することができません。"/>
              <Calendar title="出荷日" :value.sync="item.deliveryDate" :editor="editor" :required="true" :enabled="isEditable(item.state, item.deliveryFlag, true)" @changed="onChangeCurrency(item)" />
              <AtcCounterpart title="得意先" :value.sync="item.counterpart" :editor="editor" :needsCustomer="true" :required="true" :enabled="isEditable(item.state, item.deliveryFlag, true)" @update:value="onChangeCustomer(item, editor)"  tooltip="受注を受けた取引先です。【取引先種別】が【得意先】になっているデータが選択できます。【納入区分】が直送になっている場合はこの画面からは変更出来ません。"/>
              <AtcCounterpart title="納入先" :value.sync="item.receiver" :editor="editor" :needsCustomer="true" :needsReceiver="true" :customer="item.counterpart" :enabled="isEditable(item.state, item.deliveryFlag, true)" :isDirectEditEnabled="false" @update:value="onChangeReceiver(item, editor)" tooltip="商品の届け先です。【取引先一覧】の【取引先種別】が【納入先】になっているデータ､もしくは【得意先】に設定した得意先が設定可能です。"/>            
              <TextBox title="納入区分" :value="item.deliveryFlag | deliveryFlagsHasServices" :editor="editor" v-if="item.deliveryFlag==deliveryFlags.Direct" :enabled="false" tooltip="商品を在庫から出荷するか、お客様に直送するかの区分が表示されます。【直送】にするためには【受注一覧】または【受注明細一覧】から【発注処理】をする必要があります。"/>
              <RadioButton title="納入区分" :value.sync="item.deliveryFlag" :list="$api.useStockFunction ? 'deliveryFlagsNoDirect' : 'deliveryFlagsNoDirectNoStock'"  v-if="item.deliveryFlag!=deliveryFlags.Direct" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, true)" :isDirectEditEnabled="false" @update:value="onChangeDeliveryFlag(item)" tooltip="商品を在庫から出荷するか、お客様に直送するかの区分が表示されます。【直送】にするためには【受注一覧】または【受注明細一覧】から【発注処理】をする必要があります。"/>
              <AtcCounterpart title="出庫倉庫" :value.sync="item.warehouse" :editor="editor" :required="item.deliveryFlag==deliveryFlags.Stock" :needsWarehouse="true" :enabled="isEditable(item.state, item.deliveryFlag, true)&&item.deliveryFlag==deliveryFlags.Stock" tooltip="商品を出荷する倉庫です。【取引先一覧】の【取引先種別】が【倉庫】になっているデータが選択できます。【納入区分】が直送になっている場合は設定出来ません。"/>
              <ComboBox title="取引通貨" v-if="hasLicenseCurrency" :value.sync="item.currencyCode" list="currency" :required="true" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag,true)" @changed="onChangeCurrency(item)" nullValue="" />                
              <NumericBox title="出荷金額" :value.sync="item.dealAmountFC" :editor="editor" :enabled="false" :decimals="$api.decimals[item.currencyCode]" tooltip="【出荷明細】に登録されている【単価】×【出荷数量】の合計金額が表示されます。"/>
              <NumericBox title="現金清算済み金額" :value="item.cashReceived" v-if="item.cashReceived != 0" :editor="editor" :enabled="false" :decimals="$api.decimals[item.currencyCode]" tooltip="既に清算済みの金額です。"/>
              <TextBox title="税計算区分" :value="(item.counterpart ? item.counterpart.taxType : '') | taxTypes" :editor="editor" :enabled="false" tooltip="【得意先】に設定した得意先の【税計算区分】が表示されます。"/>              

            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <!-- <template v-if="hasLicenseCurrency">
                <TextBox title="取引通貨" :value="item.currencyCode | currency" :editor="editor" :enabled="item.orderItem && isEditable(item.state, item.deliveryFlag,true)" @changed="onChangeCurrency(item)"/>              
                <NumericBox title="計上レート" :value.sync="item.exchangeRate" :editor="editor" :enabled="false" :decimals="6" />
              </template> -->
              <AtcProjectItem title="案件" :value.sync="item.projectItem" :editor="editor"  :enabled="!item.hasOrder && isEditable(item.state, item.deliveryFlag, true)"  tooltip="登録済み案件の選択、新規案件の作成が行えます。受注伝票が紐づいている場合変更はできません。"/>              
              <AtcSegment title="部門" :value.sync="item.segment" :editor="editor" :required="true" :enabled="!item.hasOrder && isEditable(item.state, item.deliveryFlag, true)" tooltip="出荷を担当する部門です。【部門一覧】のデータから選択することができます。【納入区分】が直送になっている場合はこの画面からは変更出来ません。"/>
              <AutoComplete title="担当者" :value.sync="item.pic" :editor="editor" list="user" :required="true" :enabled="isEditable(item.state, item.deliveryFlag, true)" tooltip="案件を担当する人を選択します。【ユーザー】のデータを選択することができます。"/>              
              <TextBox title="出荷管理番号" :value.sync="item.refNo" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="30" tooltip="任意で出荷に対して管理番号を入力することができます。"/>
              <!-- <ComboBox title="状態" :value.sync="item.state" :editor="editor" list="salesDeliveryStatus" :enabled="false" /> -->
              <!-- <ComboBox title="所有者" :value.sync="item.workflowHolder" list="userGroup" :editor="editor" :enabled="false" /> -->
              <TextBox title="ピッキング番号" :value.sync="item.pickingNo" :editor="editor" :enabled="false"/>
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="出荷データを最後に編集した日時が表示されています。"/>
              <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_salesDelivery" :required="$api.perms.hasWorkflow('salesDelivery')" :enabled="$api.perms.hasWorkflow('salesDelivery') && $api.perms.isEntryStatus(item)" :nullValue="0" tooltip="出荷時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【出荷管理】になっているデータから選択ができます。"/>
              <TextBox title="状態" :value="$api.perms.getWorkflowStateLabel(item)" :enabled="false" tooltip="出荷データの今現在の状態が表示されており､確定や業務処理を行う事で変化します。"/>                       
            </template>
          </EditPanel>
        </template>
        <!-- 出荷明細タブ -->
        <template slot="tab1" slot-scope="{ item,editor}">
          <GrdVoucherItem :voucherNo="item.deliveryNo" :voucherType="voucherTypes.SalesDelivery" :voucherItemType="voucherTypes.SalesDeliveryItem" :isBarcodeInspection="isBarcodeInspection" ref="salesDeliveryItems" :showCheckBox="true"  :comparer="(a,b)=>a.auditNo == b.auditNo">
              <template slot="menu"  slot-scope="{parent}" >
              <Button class="button" @click="showBundleAddDeliveryItemDialog"  :perm="$refs.mainList.perm + '.edit'"  caption="明細の追加" :disabled="(editor.owner.isAdding == false && editor.isEdit) || disabledAddItemButton(item) || ($refs.salesDeliveryItems && $refs.salesDeliveryItems.isLoading)" icon="add" tooltip="選択した出荷に紐づく【出荷明細】の登録を行います。"/>
              <Button class="button" @click="parent.onDelete().then(()=>$refs.mainList.reloadSelected())" :perm="$refs.mainList.perm + '.edit'"   caption="明細の削除" :disabled="editor.isEdit || disabledAddItemButton(item) || parent.isLoading" icon="delete"/>                            
              <Button class="button" @click="showBookSalesDialog(item)"  :perm="$refs.mainList.perm + '.process'"  caption="明細請求処理" :disabled="editor.isEdit || disabledDeliveryItemFuncButton(item) || ($refs.salesDeliveryItems && $refs.salesDeliveryItems.isLoading)" tooltip="選択した複数の明細に対して、請求処理を行い請求書番号を発行します。"/>                        
              <Button class="button" @click="showReturnDeliveryDialog(item)"  :perm="$refs.mainList.perm + '.process'"  caption="返品処理" :disabled="editor.isEdit || disabledReturnDeliveryItemFuncButton(item) || ($refs.salesDeliveryItems && $refs.salesDeliveryItems.isLoading)" tooltip="選択した明細に対して､返品の伝票を作成します。"/>
              </template>
              <PopupEditor slot="popupEditor" slot-scope="{parent}" v-model="parent.showEditor" title="出荷明細" mode="editor" :isInsertMode="false" @closing="args=>{parent.replaceItem(args.target);$refs.mainList.reloadSelected();}">
                <SalesDeliveryItem slot-scope={popup} :popup="popup" :deliveryItemNo="parent.editItem ? parent.editItem.deliveryItemNo: null"/>
              </PopupEditor>                      
          </GrdVoucherItem>
        </template>           
        <!-- 売上諸掛タブ -->
        <!-- <template slot="tab2" slot-scope="{ item}">
          <GrdVoucherItem :voucherNo="item.deliveryNo" :voucherType="voucherTypes.SalesDelivery" :voucherItemType="voucherTypes.SalesCharge" />
        </template>                     -->
        <!-- 記載事項タブ -->
        <template slot="tab2" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 記載事項タブ 左側 -->
            <template slot="left">
              <TextBox title="決済条件" :value.sync="item.paymentTerm" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" tooltip="任意で決済に関わる情報を最大50文字まで入力でき、内容を帳票に載せることができます。"/>
              <TextBox title="特記事項" :value.sync="item.remark" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="200" rows="5" tooltip="任意で特記したい情報を最大200文字まで入力でき、内容を帳票に載せることができます。"/>
              <TextBox title="出荷指示" :value.sync="item.deliveryInstruction" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="200" rows="5" tooltip="任意で出荷に関わる指示を最大200文字まで入力でき、内容を帳票に載せることができます。"/>

            </template>
            <!-- 記載事項タブ 右側 -->
            <template slot="right">
              <TextBox title="備考" :value.sync="item.description" :editor="editor" :enabled="isEditable(item.state)" length="200" rows="12" tooltip="任意で出荷に関わる情報を最大200文字まで入力でき、内容を帳票に載せることができます。"/>

            </template>
          </EditPanel>
        </template>
        <!-- 納入先詳細タブ -->
        <template slot="tab3" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 納入先詳細タブ 左側 -->
            <template slot="left">
              <TextBox title="納入先名称" :editor="editor" :value.sync="item.outputReceiverName" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />

             <TextBox title="担当部署名" :editor="editor" :value.sync="item.outputReceiverPICSection" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="担当者" :editor="editor" :value.sync="item.outputReceiverPIC" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="30" />
              <TextBox title="敬称" :editor="editor" :value.sync="item.outputReceiverPICHonorificTitle" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="5" />
              <div style="display:flex;">
                <TextBox title="郵便番号" :editor="editor" :value.sync="item.outputReceiverPostalCode" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
                <Button class="button cx_itembutton" style="margin-left:10px"  @click="$api.getAddress(item.outputReceiverPostalCode).then(res => item.outputReceiverAddress1 = res)" caption="住所取得" :disabled="!isEditable(item.state, item.deliveryFlag, false)  || editor.isEdit ==false" tooltip="郵便番号から住所を取得します"/>
              </div>              
              <TextBox title="住所1" :editor="editor" :value.sync="item.outputReceiverAddress1" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="住所2" :editor="editor" :value.sync="item.outputReceiverAddress2" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="住所3" :editor="editor" :value.sync="item.outputReceiverAddress3" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />

            </template>
            <!-- 納入先詳細タブ 右側 -->
            <template slot="right">     
              <TextBox title="電話番号" :editor="editor" :value.sync="item.outputReceiverTelNo" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="20" />
              <TextBox title="FAX番号" :editor="editor" :value.sync="item.outputReceiverFaxNo" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="20" />
              <ComboBox title="運送会社" :editor="editor" :value.sync="item.forwarder" list="forwarderFlags" :enabled="isEditable(item.state, item.deliveryFlag, false)" :showDefault="false" tooltip="選択した【運送会社】によって【配達時間帯】の候補の切替を行うことができます。" />
              <Calendar title="配達指定日" :editor="editor" :value.sync="item.arrivalDate" :enabled="isEditable(item.state, item.deliveryFlag, false)" />
              <ComboBox title="配達時間帯" :editor="editor" :value.sync="item.arrivalHour" :provider="()=>forwarderTimezoneFlags(item)" :enabled="isEditable(item.state, item.deliveryFlag, false)" :showDefault="false" tooltip="商品を配達する時間帯を選択します。【運送会社】で登録した会社の時間帯を選択することができます。" />
              <NumericBox title="配達個口数" :editor="editor" :value.sync="item.shippingBoxes" :enabled="isEditable(item.state, item.deliveryFlag, false)" max="99" min="1" tooltip="送付する荷物の個口数を入力することができます。この値は送り状を発行する時に利用されます。" />
              <TextBox title="送り状品名" :editor="editor" :value.sync="item.shippingDescription" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="25" tooltip="【送り状品名】を入力します。この値は送り状を発行する時に利用されます。" />
              <TextBox title="送り状No" :editor="editor" :value.sync="item.shippingNo" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="25" tooltip="【送り状No】を入力することができます。帳票に番号を出力したり、メール送信をする際にメール本文に番号を記載できます。" />
             </template>
          </EditPanel>
        </template>        
        <!-- 予備項目タブ -->
        <template slot="tab4" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 予備項目タブ 左側 -->
            <template slot="left">
              <TextBox title="voucher_text1" :value.sync="item.reserveText1" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="voucher_text2" :value.sync="item.reserveText2" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="voucher_text3" :value.sync="item.reserveText3" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="voucher_text4" :value.sync="item.reserveText4" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="voucher_text5" :value.sync="item.reserveText5" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="voucher_text6" :value.sync="item.reserveText6" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <AutoComplete title="voucher_list1" :value.sync="item.reserveList1" :editor="editor" list="category_31" :enabled="isEditable(item.state, item.deliveryFlag, false)" path="/master/Category" tooltip="任意で区分を設定できます。選択項目は【区分一覧】から追加・修正が可能です。"/>
              <AutoComplete title="voucher_list2" :value.sync="item.reserveList2" :editor="editor" list="category_32" :enabled="isEditable(item.state, item.deliveryFlag, false)" path="/master/Category" tooltip="任意で区分を設定できます。選択項目は【区分一覧】から追加・修正が可能です。"/>
              <AutoComplete title="voucher_list3" :value.sync="item.reserveList3" :editor="editor" list="category_33" :enabled="isEditable(item.state, item.deliveryFlag, false)" path="/master/Category" tooltip="任意で区分を設定できます。選択項目は【区分一覧】から追加・修正が可能です。"/>

            </template>
            <!-- 予備項目タブ 右側 -->
            <template slot="right">
              <Calendar title="voucher_date1" :value.sync="item.reserveDate1" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" :deletable="true" />
              <Calendar title="voucher_date2" :value.sync="item.reserveDate2" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" :deletable="true" />
              <Calendar title="voucher_date3" :value.sync="item.reserveDate3" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" :deletable="true" />
              <TextBox title="voucher_memo1" :value.sync="item.reserveMemo1" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="200" rows="2" />
              <TextBox title="voucher_memo2" :value.sync="item.reserveMemo2" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="200" rows="2" />
              <TextBox title="voucher_memo3" :value.sync="item.reserveMemo3" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="200" rows="2" />

            </template>
          </EditPanel>
        </template>

        <!-- ワークフロータブ -->
        <template slot="tab5" slot-scope="{ item, editor }">
          <MessageList class="cx_matter_message" :item="item" :editor="editor" />
        </template>
        <!-- 更新履歴タブ -->
        <template slot="tab6" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
        <!-- 添付ファイルタブ -->
        <template slot="tab7" slot-scope="{ item, editor }">
          <ListFiles :editor="editor" title="添付ファイル" :height="300" :parentKey="item.auditName" :parentId="item.auditNo" :electronicBookMode="tenantSettings.electronicBookMode" />
        </template>
      </Editor>
      <!--  明細一括入力ダイアログ-->
      <ListDialog ref="bundleAddDeliveryItemDialog" title="明細一括入力" modelName="SalesDeliveryItem" :captions="badiCaptions" :widths="badiWidths" :exec="submitBundleAddDeliveryItem" :onCreate="onItemCreate"  :height="235" :width="1000">
        <Button slot="buttons" class="button" @click="showStockBalance = true" caption="在庫選択" icon="add_circle" v-if="showStockBalanceButton"/>        
        <TextBox :slot="badiSlots[0]" slot-scope="{ item, editor }" :value.sync="item.specificPurchaseItemNo" :editor="editor" :required="badiPurchaseItemIdRequreid"  :enabled="badiPurchaseItemIdRequreid" />
        <AtcCommodity :slot="badiSlots[1]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.commodity" :required="true" @update:value="onChangeCommodity(item)" :enabled="item.isStockBalance == false"/>
        <TextBox :slot="badiSlots[2]" slot-scope="{ item, editor }" :value.sync="item.commodityName" :editor="editor" :required="true" length="100" />
        <AtcSKU :slot="badiSlots[3]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.sku" :commodity="item.commodity" @update:value="getPriceAndTaxCode(item)"  :enabled="item.isStockBalance == false"/>
        <NumericBox :slot="badiSlots[4]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.stockQuantity2" :enabled="false"/>
        <AtcConversion :slot="badiSlots[5]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.uom2" :commodity="item.commodity" :required="true" @update:value="getPriceAndTaxCode(item)" /> 
        <NumericBox :slot="badiSlots[6]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.quantity" :required="true" min="-99999999.999" max="99999999.999" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" @update:value="getPriceAndTaxCode(item)" />
        <NumericBox :slot="badiSlots[7]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.unitPrice" :required="!tenantSettings.noCheckPriceRequired" min="-99999999999.999999" max="99999999999.999999" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale"/>
        <AtcTaxCode :slot="badiSlots[8]" slot-scope="{ item, editor }" :editor="editor" :taxType="listView.selected.counterpart.taxType"  :value.sync="item.taxCode" list="taxCode" :required="true" />

        <TextBox :slot="badiSlots[9]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText1  != usedTypes.CommodityMemo" :value.sync="item.reserveText1" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText1,item.isStockBalance)" />
        <TextBox :slot="badiSlots[9]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText1:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText1)" />
        <TextBox :slot="badiSlots[10]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText2  != usedTypes.CommodityMemo" :value.sync="item.reserveText2" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText2,item.isStockBalance)" />
        <TextBox :slot="badiSlots[10]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText2:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText2)" />
        <TextBox :slot="badiSlots[11]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText3  != usedTypes.CommodityMemo" :value.sync="item.reserveText3" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText3,item.isStockBalance)" />
        <TextBox :slot="badiSlots[11]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText3:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText3)" />
        <TextBox :slot="badiSlots[12]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText4  != usedTypes.CommodityMemo" :value.sync="item.reserveText4" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText4,item.isStockBalance)" />
        <TextBox :slot="badiSlots[12]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText4  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText4:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText4)" />
        <TextBox :slot="badiSlots[13]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText5  != usedTypes.CommodityMemo" :value.sync="item.reserveText5" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText5,item.isStockBalance)" />
        <TextBox :slot="badiSlots[13]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText5  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText5:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText5)" />
        <TextBox :slot="badiSlots[14]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText6  != usedTypes.CommodityMemo" :value.sync="item.reserveText6" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText6,item.isStockBalance)" />
        <TextBox :slot="badiSlots[14]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText6  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText6:''" :editor="editor" length="50" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveText6)" />
        <TextBox :slot="badiSlots[15]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo1  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo1" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo1,item.isStockBalance)" />
        <TextBox :slot="badiSlots[15]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo1:''" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo1)" />
        <TextBox :slot="badiSlots[16]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo2  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo2" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo2,item.isStockBalance)" />
        <TextBox :slot="badiSlots[16]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo2:''" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo2)" />
        <TextBox :slot="badiSlots[17]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo3  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo3" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo3,item.isStockBalance)" />
        <TextBox :slot="badiSlots[17]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo3:''" :editor="editor" length="200" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveMemo3)" />
        <Calendar :slot="badiSlots[18]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate1  != usedTypes.CommodityMemo" :value.sync="item.reserveDate1" :editor="editor" :deletable="true" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate1,item.isStockBalance)" />
        <Calendar :slot="badiSlots[18]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate1: null" :editor="editor" :deletable="true" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate1)" />
        <Calendar :slot="badiSlots[19]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate2  != usedTypes.CommodityMemo" :value.sync="item.reserveDate2" :editor="editor" :deletable="true" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate2,item.isStockBalance)" />
        <Calendar :slot="badiSlots[19]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate2: null" :editor="editor" :deletable="true" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate2)" />
        <Calendar :slot="badiSlots[20]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate3  != usedTypes.CommodityMemo" :value.sync="item.reserveDate3" :editor="editor" :deletable="true" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate3,item.isStockBalance)" />
        <Calendar :slot="badiSlots[20]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate3: null" :editor="editor" :deletable="true" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveDate3)" />
        <AutoComplete :slot="badiSlots[21]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList1  != usedTypes.CommodityMemo" :value.sync="item.reserveList1" :editor="editor" list="category_41" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList1,item.isStockBalance)" path="/master/Category" />
        <AutoComplete :slot="badiSlots[21]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList1:''" :editor="editor" list="category_41" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList1)" path="/master/Category" />
        <AutoComplete :slot="badiSlots[22]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList2  != usedTypes.CommodityMemo" :value.sync="item.reserveList2" :editor="editor" list="category_42" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList2,item.isStockBalance)" path="/master/Category" />
        <AutoComplete :slot="badiSlots[22]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList2:''" :editor="editor" list="category_42" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList2)" path="/master/Category" />
        <AutoComplete :slot="badiSlots[23]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList3  != usedTypes.CommodityMemo" :value.sync="item.reserveList3" :editor="editor" list="category_43" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList3,item.isStockBalance)" path="/master/Category" />        
        <AutoComplete :slot="badiSlots[23]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList3:''" :editor="editor" list="category_43" :enabled="isEditable2(tenantSettings.usedTypeDetailReserveList3)" path="/master/Category" />        
          <!-- 明細一括入力時の在庫選択画面～itemが必要なのでここに配置=>移動 -->
        <PopupEditor  slot="header" v-model="showStockBalance" title="出荷対象の在庫を選択してください" mode="list" v-if="listView.selected" >
          <StockBalance slot-scope={popup} :popup="popup" :closingDate="listView.selected.deliveryDate" :segment="listView.selected.segment" :warehouse="listView.selected.warehouse" :projectItem="listView.selected.projectItem" :excludeProject="listView.selected.projectItem == null" :isStockPopup="true" ref="stockBalance"/>
          <button slot="buttons" class="btn btn-secondary" @click="showStockBalance = false">キャンセル</button>
          <button slot="buttons" class="btn btn-primary" @click="onAddDeliveryItems(listView.selected)" >追加する</button>
        </PopupEditor>     
      </ListDialog>      
    </template>
    <template slot="modal">
      <!-- 引当情報削除 -->
      <ListDialog ref="deliveryDeleteDialog" title="確認メッセージ" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="onSalesDeliveryDelete">
        <template slot="header">
          <Label :text="deleteMessage" :fontSize="16" fontWeight="300"/> 
          <CheckBox title="引当を解除する" :value.sync="allocateDelete" list="isAllocateDelete" tooltip="引当を解除する場合、受注が紐づく出荷明細も同時に削除されます。" />
        </template>
      </ListDialog>
      <b-modal class="cx_picking" v-model="showPicking" v-if="showPicking" title="ピッキング処理" @ok="createPicking" :no-close-on-backdrop="true" centered>
        <Calendar title="出荷日" :value.sync="pickingDate" :isEdit="true" :required="true" ref="pickingDate"/>
        <AutoComplete title="担当者" :value.sync="pickingPic" :isEdit="true" list="user" :required="true"  ref="pickingPIC"/>                      
        <TextBox title="備考" :value.sync="pickingDescription"  :isEdit="true" rows="4"/>        
        <span>上記の内容でピッキング伝票を作成してよろしいですか？</span>
      </b-modal>
    </template>    
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import { CreatePickingQuery } from '@/tenant/models/All';


@Component
export default class SalesDeliveryView extends Vue {
  public bookSales = Components.BookSales;
  public returnDelivery = Components.ReturnDelivery;
  public items: Common.SalesDelivery[] = new Array(0);
  public params: Common.DeliveryQuery = new Common.DeliveryQuery(Common.SalesPurchaseFlags.Sales);
  public importQuery = new Common.DeliveryImportQuery('出荷',Common.SalesPurchaseFlags.Sales);
  public exportQuery = new Common.DeliveryExportQuery('出荷',this.params,Common.SalesPurchaseFlags.Sales);
  public usedTypes = Common.UsedTypes;  
  public deliveryFlags = Common.DeliveryFlags;
  public hasLicenseCurrency: boolean = false;
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'deliveryNo', text: '出荷番号' },
    { value: 'deliveryDate', text: '出荷日' },
    { value: 'counterpart', text: '得意先' },
    { value: 'receiver', text: '納入先' },
    { value: 'warehouse', text: '出庫倉庫' },
    { value: 'projectItem', text: '案件' },      
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'refNo', text: '出荷管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tenantSettings: Common.TenantSettings = null;
  public voucherTypes = Common.voucherTypes;  
  @Prop() public deliveryNo:string;
  @Prop() public pickingNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor;  
  
  public get isBarcodeInspection(){
    return (this.$api.tenantSettings.inspectionMode & Common.InspectionModes.shipping) > 0 ;
  }
  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([],0, 'grid');

  //タブ表示制御
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true, true, true];
  public tabVisiblesOnInsert: Array<boolean> = [true, true, true, true, true, false, false, false, false];  

  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);

    // タブ表示の制御
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction); // 予備項目タブ
    this.$set(this.tabVisiblesOnInsert, 4, this.$api.useStockFunction); // 予備項目タブ

    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('出荷番号', 150),
      new Common.GridItemConfiguration('ワークフロー', 220),
      new Common.GridItemConfiguration('出荷日', 150),
      new Common.GridItemConfiguration('得意先', 150),
      new Common.GridItemConfiguration('納入先', 150),
      new Common.GridItemConfiguration('納入先名称', 150),
      new Common.GridItemConfiguration('納入区分', 150),
      new Common.GridItemConfiguration('出庫倉庫', 150),
      new Common.GridItemConfiguration('取引通貨', 150,this.hasLicenseCurrency),
      // new Common.GridItemConfiguration('計上レート', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('出荷金額', 150),
      new Common.GridItemConfiguration('税計算区分', 150),
      new Common.GridItemConfiguration('案件', 150),             
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),
      new Common.GridItemConfiguration('出荷管理番号', 150),
      new Common.GridItemConfiguration('運送会社', 150),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),
    );


    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    // インポート・エクスポートの制御
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;

    // 検索条件を設定する
    if(this.deliveryNo) {
      this.params.deliveryNo = this.deliveryNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}

    if (this.pickingNo) {
      this.params.pickingNo = this.pickingNo;
    }
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
    // 子画面用ワークフロー情報をロードする
    this.$api.formatter.ensureListLoaded('workflow_aloneInvoice');
    this.$api.formatter.ensureListLoaded('workflow_carryOverInvoice');
  }

  public forwarderTimezoneFlags(item: Common.SalesDelivery){
    if (item.forwarder == Common.ForwarderFlags.Default) return new Array(0);

    var timeZoneArray = new Array();
    if (item.forwarder == Common.ForwarderFlags.Sagawa) {
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Default);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone0812);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1214);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1416);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1618);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1820);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1821);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1921);
    } else if (item.forwarder == Common.ForwarderFlags.Yamato) {
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Default);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone0812);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1416);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1618);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1820);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1921);
    } else if (item.forwarder == Common.ForwarderFlags.Seinou) {
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Default);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone0812s);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1220);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone0912);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1217);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1720);
    }

    var list = this.$api.formatter.getOptions("forwarderTimezoneFlags");
    var result = new Array(0);
    list.forEach(element => {
        if (timeZoneArray.includes(element.value) == true) result.push(element) ;            
    });
    return result;
  }

  public async onCreate(obj: Common.SalesDelivery) {
    const workflows = this.$api.formatter.getOptions('workflow_salesDelivery');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.pic = this.$api.auth.userId;
    obj.deliveryDate = new Date().getCalendarDate();
    obj.deliveryFlag = (this.$api.useStockFunction) ? Common.DeliveryFlags.Stock : Common.DeliveryFlags.Services;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
    //出荷明細タブのリロード
    (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();           
  }

  // 状態から編集可能か判別する
  public isEditable(state: Common.DeliveryStatus, flag:Common.DeliveryFlags, isDisableDirect:boolean):boolean{
    if(isDisableDirect && flag == Common.DeliveryFlags.Direct) return false;
    if(state == Common.DeliveryStatus.SalesDeliveryPostWaiting) return true;
    return false;
  }

  // 得意先変更時に得意先の通貨を設定する
  public onChangeCustomer(item: Common.Delivery, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.currencyCode = item.counterpart ? item.counterpart.currencyCode : '';
    if (item.counterpart && item.counterpart.salesPerson) item.pic = item.counterpart.salesPerson;    
    item.onChangeCounterpart();
  }

  // 納入先変更時に納入先詳細を設定する
  public onChangeReceiver(item: Common.Order, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.onChangeReceiver();
  }

  public async onChangeCurrency(item: Common.Delivery){
    const query = new Common.GetExchangeRateQuery();
    query.currency = item.currencyCode;
    query.startDate = item.deliveryDate;
    this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      item.exchangeRate = exchangeRate ? exchangeRate.rate : 1;
    });
  }

  public onChangeDeliveryFlag(item: Common.Delivery){
    if(item.deliveryFlag == Common.DeliveryFlags.Services) item.warehouse = null;
  }

  // 一覧選択時に明細表示ボタン、部門の非活化状態確認
  public onSelectedMain(index: number, selected: Common.Delivery) {
    this.checkItemData(selected);
  }

  // 明細表示ボタンの非活性判別
  public disabledShowItemButton: boolean = true;
  public  checkItemData(delivery:Common.Delivery){
    this.disabledShowItemButton = true;
    
    var query = new Common.GetDeliveryItemQuery();
    query.deliveryNo = delivery.deliveryNo;
    this.$api.execute(query).then(res => {
      this.disabledShowItemButton = !res.hasItem;
      delivery.hasOrder = res.hasOrder;
    });
  }
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.SalesDelivery){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.SalesDelivery, sourceNo : item.deliveryNo},this.$el);
  }
  // 出荷明細一覧を表示
  public showSalesDeliveryItem() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.Delivery;
    if(obj.state == Common.DeliveryStatus.SalesDeliveryPostWaiting){
      let routeData = this.$router.resolve(String.format('/sales/SalesDeliveryItem?deliveryNo={0}', obj.deliveryNo));
      window.open(routeData.href, '_blank');
    }else{
      let routeData = this.$router.resolve(String.format('/sales/InvoiceItem?deliveryNo={0}', obj.deliveryNo));
      window.open(routeData.href, '_blank');
    }
  }

  // 明細一括入力ボタンの非活性判別
  public disabledAddItemButton(delivery: Common.SalesDelivery){
    return delivery.state != Common.DeliveryStatus.SalesDeliveryPostWaiting;
  }

  // 明細一括入力ダイアログ用プロパティ
  public badiCaptions = new Array();
  public badiWidths = new Array();
  public badiSlots = new Array();
  public badiGridConfig:Common.GridConfiguration =null;
  public badiPurchaseItemIdRequreid: boolean; // 入荷明細番号必須・活性を判別

  // 明細一括入力ダイアログを表示
  public showBundleAddDeliveryItemDialog() {
    const selectedDelivery = (this.$refs.mainList as Components.ListView).selected as Common.Delivery;
      // 新規の場合、編集中のものを設定
    if(selectedDelivery.counterpart == null){
      this.$api.modal.show('', '得意先を指定してください。', true, null);
      return ;
    }
    if(selectedDelivery.deliveryFlag == Common.DeliveryFlags.Stock && selectedDelivery.warehouse == null){
      this.$api.modal.show('', '出庫倉庫を指定してください。', true, null);
      return ;
    }
    if(selectedDelivery.deliveryFlag == Common.DeliveryFlags.Stock) this.showStockBalanceButton = true;
    else this.showStockBalanceButton = false;
    // プロパティの設定
    this.badiPurchaseItemIdRequreid = selectedDelivery.segment.priceCalculationMethod == Common.PricingTypes.Specific;

    // 明細の予備項目表示の可変対応
    this.badiGridConfig = new Common.GridConfiguration([],0,'col');
    this.badiGridConfig.setGridItems(
      new Common.GridItemConfiguration('入荷明細番号', 150,this.badiPurchaseItemIdRequreid),
      new Common.GridItemConfiguration('商品', 250),
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('SKU', 200, this.$api.useStockFunction),
      new Common.GridItemConfiguration('庫内数量', 130),      
      new Common.GridItemConfiguration('単位', 120),
      new Common.GridItemConfiguration('出荷数量', 130),
      new Common.GridItemConfiguration('単価', 130),
      new Common.GridItemConfiguration('税区分', 120)      
    );
    this.badiGridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,false,false,true));//商品識別情報＋在庫識別情報＋商品メモ＋入出荷メモ
    this.badiCaptions =this.badiGridConfig.gridCaptions;
    this.badiWidths = this.badiGridConfig.gridWidths;
    this.badiSlots = this.badiGridConfig.gridSlots;

    // ダイアログの表示
    var items = new Array();
    var instance = new Common.SalesDeliveryItem();
    //instance.taxCode = selectedDelivery.counterpart.taxCode;
    //納入区分が在庫の場合は明細行を追加しない
    if(selectedDelivery.deliveryFlag == Common.DeliveryFlags.Services) items.push(instance);
    (this.$refs.bundleAddDeliveryItemDialog as Components.ListDialog).items = items;
    (this.$refs.bundleAddDeliveryItemDialog as Components.ListDialog).showDialog();
  }

  //明細一括入力ダイアログの予備項目の活性・非活性を切り替える
  public isEditable2(usedType: Common.UsedTypes, isStockBalance = false){
    //商品識別情報・在庫識別情報・入出荷メモは活性。それ以外は非活性
        if(usedType == Common.UsedTypes.CommodityAttribute && isStockBalance == false)  return true;
        if(usedType == Common.UsedTypes.StockAttribute && isStockBalance == false) return true;
        if(usedType == Common.UsedTypes.DeliveryMemo) return true;
        return false;
  }

  // 商品変更時に商品名・単価・税区分・予備項目を設定する
  public onChangeCommodity(item:Common.DeliveryItem){
    item.onChangeCommodity(this.tenantSettings);
    this.getPriceAndTaxCode(item);
  }

  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.DeliveryItem){
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.Delivery;
    this.$api.execute(new Common.DeliveryGetItemPriceQuery(parent, item)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    });
  }

  //行追加時に税区分の初期値を設定 ⇒ 商品選択時にセットされるため廃止
  public async onItemCreate(obj:Common.DeliveryItem){
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.Delivery;
    //obj.taxCode = parent.counterpart.taxCode;
    return Promise.resolve(obj);
  }

  public showStockBalance:boolean = false;
  public showStockBalanceButton: boolean = false;
  public onAddDeliveryItems(parent:Common.Delivery){
    //選択された在庫からdeliveryItemを生成する
    var selectedItems = ((this.$refs.stockBalance as Components.StockBalance).$refs.mainList as Components.ListView).selectedItems as Common.StockBalance[];
    selectedItems.forEach(stock =>{
      var deliveryItem = new Common.SalesDeliveryItem();
      deliveryItem.isStockBalance = true;
      deliveryItem.stockQuantity2 = stock.stockQuantity;
      deliveryItem.commodity = stock.stockKey.commodity;
      deliveryItem.commodityName = deliveryItem.commodity ? deliveryItem.commodity.name: '';
      deliveryItem.sku = stock.stockKey.sku;
      deliveryItem.reserveText1 = stock.stockKey.reserveText1;
      deliveryItem.reserveText2 = stock.stockKey.reserveText2;
      deliveryItem.reserveText3 = stock.stockKey.reserveText3;
      deliveryItem.reserveText4 = stock.stockKey.reserveText4;
      deliveryItem.reserveText5 = stock.stockKey.reserveText5;
      deliveryItem.reserveText6 = stock.stockKey.reserveText6;               
      deliveryItem.reserveMemo1 = stock.stockKey.reserveMemo1;
      deliveryItem.reserveMemo2 = stock.stockKey.reserveMemo2;
      deliveryItem.reserveMemo3 = stock.stockKey.reserveMemo3;                  
      deliveryItem.reserveDate1 = stock.stockKey.reserveDate1;
      deliveryItem.reserveDate2 = stock.stockKey.reserveDate2;
      deliveryItem.reserveDate3 = stock.stockKey.reserveDate3;          
      deliveryItem.reserveList1 = stock.stockKey.reserveList1;
      deliveryItem.reserveList2 = stock.stockKey.reserveList2;
      deliveryItem.reserveList3 = stock.stockKey.reserveList3;           
      (this.$refs.bundleAddDeliveryItemDialog as Components.ListDialog).onAddItem(deliveryItem);                  
    });
    this.showStockBalance = false; 
  }
public submitBundleAddDeliveryItemRun(){
  const items = (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).items;
  if(items.length > 0) this.submitBundleAddDeliveryItem(items);
}
  // 明細一括入力の実行
  public async submitBundleAddDeliveryItem(list: Array<Common.DeliveryItem>) {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesDelivery;
    var items = new Array();
    for(var obj of list){
      obj.delivery = parent;
      obj.segment = parent.segment;
      obj.warehouse = parent.warehouse;
      items.push(obj);
    }
    if(items.filter(item => !item.commodity.isNoStock).length > 0 && parent.warehouse == null){
      this.$api.modal.show('無効な操作','倉庫の指定がありません。在庫から出荷する場合、出庫倉庫を指定してください。',true,null);
      return true;
    }
    //新規追加時は明細を一時的に保持する
    if((this.$refs.mainList as Components.ListView).isInsertMode){
     (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).mergeItems(items);
      return true;
    }
    var query = new Common.BundleAddDeliveryItemQuery(Common.SalesPurchaseFlags.Sales);
    query.deliveryItems = items;
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/sales/SalesDeliveryItem?deliveryNo={0}', parent.deliveryNo));
    // });

    return this.$api.execute(query).then(res => {
      //出荷金額が更新されるのでリストを更新する
       (this.$refs.mainList as Components.ListView).onSubmit(res).finally(()=>{
        //出荷明細タブのリロード
        (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();    
        //事後アクションダイアログを表示するためコメントアウト   
        //this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      });
      return true;
    }).catch(()=>{return false;});    
  }
  // チェックされている発注明細を取得する
  public selectedSalesDeliveryItems(){
    return (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).selectedItems;
  }
  public allSalesDeliveryItems(){
    return (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).items;
  }  
  // 請求処理ボタンの非活性判別
  public disabledDeliveryItemFuncButton(delivery:Common.SalesDelivery){
    return delivery.state != Common.DeliveryStatus.SalesDeliveryItemsOperateWaiting && delivery.state != Common.DeliveryStatus.SalesDeliveryItemsOperating;
  }
  // 返品処理ボタンの非活性判別
  public disabledReturnDeliveryItemFuncButton(delivery:Common.SalesDelivery){
    return delivery.state != Common.DeliveryStatus.SalesDeliveryItemsOperateWaiting && delivery.state != Common.DeliveryStatus.SalesDeliveryItemsOperating && delivery.state != Common.DeliveryStatus.SalesDeliveryCompleted;
  }
  // 請求処理ダイアログの表示
  public showBookSalesDialog(delivery:Common.SalesDelivery, all:boolean = false){
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.SalesDelivery;
    let componentClass = Vue.extend(this.bookSales);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          execDelivery: false,
          checkedDeliveryItems: all? this.allSalesDeliveryItems() : this.selectedSalesDeliveryItems(),
          salesDeliveryItems: this.$refs.salesDeliveryItems,
          parentMainList: this.$refs.mainList,
          parentSalesDelivery: delivery,
          parent: this,
          isItemFlag: false,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }

  // 返品処理ダイアログの表示
  public showReturnDeliveryDialog(delivery:Common.SalesDelivery){
    let componentClass = Vue.extend(this.returnDelivery);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          parentDelivery: delivery,
          checkedDeliveryItems: this.selectedSalesDeliveryItems(),
          salesPurchaseFlag: Common.SalesPurchaseFlags.Sales,
          parentMainList: this.$refs.mainList,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }

  // 業務処理・一括請求処理からの請求処理
  public showBookSalesDialogBulk(){
    const listView = this.$refs.mainList as Components.ListView;
    var deliveries = new Array();
    var checkedDeliveries = new Array();
    this.items.forEach((obj, index) => {
      if ((listView.$refs.listBox as Components.Grid).checked[index]) {
        checkedDeliveries.push(obj);
      }
    });
    if(checkedDeliveries.length == 0){
      this.$api.modal.show('', '出荷伝票を選択して下さい。', true, null);
      return;
    }
    deliveries = checkedDeliveries.filter(obj => obj.state >= Common.DeliveryStatus.SalesDeliveryItemsOperateWaiting && obj.state < Common.DeliveryStatus.SalesDeliveryCompleted);
    if(deliveries.length == 0){
      this.$api.modal.show('', '「請求処理待ち」か「請求処理中」の出荷伝票を選択してください。', true, null);
      return ;
    }
    var getCounterpart = new Common.GetDeliveriesCounterpart();
    getCounterpart.deliveries = deliveries;
    this.$api.execute(getCounterpart).then(res => {
      var counterparts = res as Common.Counterpart[];
      if(counterparts.filter(obj => (obj.payer??obj).invoiceType==Common.InvoiceTypes.SeparateInvoice).length > 0){
        this.$api.modal.show('', '個別請求が指定されている請求先に対して一括請求は行えません。個別に請求処理を行ってください。', true, null);
        return ;
      }
      // deliveryの取引先を最新化
      deliveries.forEach(obj=>obj.counterpart = counterparts.filter(cus => cus.id == obj.counterpartId)[0]);
      const bookdateTime=(deliveries[0].counterpart.payer ?? deliveries[0].counterpart).getClosingDate(deliveries[0].deliveryDate, this.$api.tenantSettings).getTime();
      if(deliveries.filter(obj => (obj.counterpart.payer ?? obj.counterpart).getClosingDate(obj.deliveryDate, this.$api.tenantSettings).getTime() != bookdateTime).length > 0){
        this.$api.modal.show('', '締日の異なる伝票が選択されています。同一の締日となる出荷伝票を選択して下さい。同一の締日は検索項目の【得意先締日】と【出荷日】で検索してください。', true, null);
        return ;
      }
    let componentClass = Vue.extend(this.bookSales);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          execDelivery: true,
          deliveries: deliveries,
          parentMainList: this.$refs.mainList,
          parent: this,
          isItemFlag: false,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
    });
  }
  
  // 業務処理・個別請求処理からの請求処理
  public showBookSalesDialogSeparate(){
    const listView = this.$refs.mainList as Components.ListView;
    var deliveries = new Array();
    var checkedDeliveries = new Array();
    this.items.forEach((obj, index) => {
      if ((listView.$refs.listBox as Components.Grid).checked[index]) {
        checkedDeliveries.push(obj);
      }
    });
    if(checkedDeliveries.length == 0){
      this.$api.modal.show('', '出荷伝票を選択して下さい。', true, null);
      return;
    }
    deliveries = checkedDeliveries.filter(obj => obj.state >= Common.DeliveryStatus.SalesDeliveryItemsOperateWaiting && obj.state < Common.DeliveryStatus.SalesDeliveryCompleted);
    if(deliveries.length == 0){
      this.$api.modal.show('', '「請求処理待ち」か「請求処理中」の出荷伝票を選択してください。', true, null);
      return ;
    }

    // 請求先の一意確認
    var payerIds = deliveries.map(obj => obj.counterpart.payerId ?? obj.counterpartId);
    if(payerIds.filter(obj => obj != payerIds[0]).length > 0){
      this.$api.modal.show('', '請求先の異なる伝票が選択されています。同一の請求先である出荷伝票を選択して下さい。', true, null);
      return ;
    }
    var getCounterpart = new Common.GetDeliveriesCounterpart();
    getCounterpart.deliveries = deliveries;

    this.$api.execute(getCounterpart).then(res => {
      var counterparts = res as Common.Counterpart[];
      // deliveryの取引先を最新化
      deliveries.forEach(obj=>obj.counterpart = counterparts.filter(cus => cus.id == obj.counterpartId)[0]);
      const bookdateTime=(deliveries[0].counterpart.payer ?? deliveries[0].counterpart).getClosingDate(deliveries[0].deliveryDate, this.$api.tenantSettings).getTime();
    let componentClass = Vue.extend(this.bookSales);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          execDelivery: true,
          deliveries: deliveries,
          parentMainList: this.$refs.mainList,
          parent: this,
          isItemFlag: false,
          isSeparate: true,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
    });
  }

  // 出荷伝票削除処理用
  public deleteMessage: string ='';
  public allocateDelete:boolean=false;
  public onDelete()
  {
      const listView = this.$refs.mainList as Components.ListView;
      let count = 0;
      (listView.$refs.listBox as Components.Grid).checked.forEach(obj => (count += obj ? 1 : 0));
      this.deleteMessage = count + '件のデータを本当に削除してよろしいですか?';
      this.allocateDelete=true;
      (this.$refs.deliveryDeleteDialog as Components.ListDialog).showDialog();
  }
  public async onSalesDeliveryDelete(){
    var listView = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((listView.$refs.listBox as Components.Grid).checked[index]) {
        obj.allocateDeleteFlag = this.allocateDelete;
      }
    });
    const targetList = new Array(0);
    this.items.forEach((obj, index) => {
      if ((listView.$refs.listBox as Components.Grid).checked[index]) {
        targetList.push(obj);
      }
    });
    listView.delete(targetList).then(()=>{
        listView.onPageChange(this.params.currentPage);
      });
      listView.$emit('updated');
  }

  //---------------- ピッキング -----------------
  public showPicking:boolean = false;
  public pickingDate: Date;
  public pickingPic: string = '';
  public pickingDescription:string = null;

  public showPickingDialog(){
    var items = (this.$refs.mainList as Components.ListView).selectedItems as Common.Delivery[];
    if(items.length == 0){
      this.$api.modal.show('無効な操作','「出荷確定待ち」の在庫出荷伝票を選択してください。',true,null);
      return true;      
    }
    if(items.filter(item => item.deliveryFlag != Common.DeliveryFlags.Stock).length > 0){
      this.$api.modal.show('無効な操作','「出荷確定待ち」の在庫出荷伝票を選択してください。',true,null);
      return true;
    }    
    if(items.filter(item => item.state != Common.DeliveryStatus.SalesDeliveryPostWaiting).length > 0){
      this.$api.modal.show('無効な操作','「出荷確定待ち」の在庫出荷伝票を選択してください。',true,null);
      return true;
    }        
    if(items.filter(item => item.warehouseId != items[0].warehouseId).length > 0){
      this.$api.modal.show('無効な操作','同一倉庫の出荷伝票を選択してください。',true,null);
      return true;
    }
    if(items.filter(item => item.segmentId != items[0].segmentId).length > 0){
      this.$api.modal.show('無効な操作','同一部門の出荷伝票を選択してください。',true,null);
      return true;
    }
    if(items.filter(item => item.pickingNo).length > 0){
      var deliveryNo = items.filter(item =>item.pickingNo).map(item =>item.deliveryNo).join('/');
      this.$api.modal.show('無効な操作','以下のピッキング処理済みの出荷伝票は選択できません。\r\n' + deliveryNo,true,null);
      return true;
    }        
    this.pickingDate = new Date().getCalendarDate(); //今日
    this.pickingPic = this.$api.auth.userId; //自分
    this.pickingDescription = null;
    this.showPicking = true;
  }
  public createPicking(event:any){

    const vDate = (this.$refs.pickingDate as any) as Components.IControl;
    const vPIC = (this.$refs.pickingPIC as any) as Components.IControl;

    var validated1 = vDate.validator.validate();
    var validated2 = vPIC.validator.validate();

    if (validated1 == false || validated2 == false) {
      event.cancel();
      return;
    }

    this.$api.execute(new CreatePickingQuery((this.$refs.mainList as Components.ListView).selectedItems, this.pickingDate,this.pickingDescription,this.pickingPic))
    .then(res =>{
      var deliveries = res as Common.SalesDelivery[];
      deliveries.forEach(obj => {
        this.$set(this.items, this.items.findIndex(item => item.deliveryNo == obj.deliveryNo),obj);
      });      
      this.$api.modal.show('処理結果','以下のピッキング伝票が作成されました。',false,()=>{
          this.$router.push(String.format('/sales/SalesPicking?pickingNo={0}',deliveries[0].pickingNo));
      },[new Common.ModalLink(deliveries[0].pickingNo, String.format('/sales/SalesPicking?pickingNo={0}',deliveries[0].pickingNo))], '伝票に移動する','閉じる');      
    });
  }
  // 個別帳票出力
  public showCustomerReport(isMail: boolean = false){
    var listView = this.$refs.mainList as Components.ListView;
    listView.selectedItems.forEach(item =>{ item.designationReportTemplateId = item.counterpart.salesDeliveryReportTemplateId;});
    if (isMail) (this.$refs.menuBar as Components.ListViewMenuBar).beforeDesignationReportSend(); // 得意先指定帳票メール送信前処理
    else (this.$refs.menuBar as Components.ListViewMenuBar).onDesignationReportGenerate();
    // const targetList = new Array(0);
    // this.items.forEach((obj, index) => {
    //   if ((listView.$refs.listBox as Components.Grid).checked[index]) {
    //     targetList.push(obj);
    //   }
    // });
    // if(targetList.length > 1){
    //   this.$api.modal.show('', '単一の伝票を選択してください。', true, null);
    //   return ;
    // }
    // var templates = (this.$refs.menuBar as Components.ListViewMenuBar).reports;
    // var template = templates.filter(obj => obj.id == targetList[0].counterpart.salesDeliveryReportTemplateId)[0];
    // if(template==null){
    //   this.$api.modal.show('', '出荷一覧指定帳票が指定されていません。取引先マスタで出荷一覧指定帳票を設定してください。', true, null, [new Common.ModalLink('設定の方法はこちら','https://support.s-flow.net/ja/articles/8159389',true)]);
    //   return ;
    // }
    // var query = new Common.ReportQuery2(template.queryName, targetList);
    // query.templateId = template.id;
    // this.$api.download(query); 
  }
}
</script>